import * as Highcharts from 'highcharts';
import * as Highstock from 'highcharts/highstock';
import AccessibilityModule from 'highcharts/modules/accessibility';

AccessibilityModule(Highcharts);
AccessibilityModule(Highstock);

export default Highcharts;
export { Highstock };
